import get from 'lodash/get';

export const getOverviewSidebarVisible = (state) => {
  return get(state, 'ui.overviewSidebarVisible');
};

export const getShowProductParts = (state) => {
  return get(state, 'ui.showProductParts');
};

export const getShowStepsNavigator = (state) => {
  return get(state, 'ui.showStepsNavigator');
};

export const getShowConfigurationOverview = (state) => {
  return get(state, 'ui.showConfigurationOverview');
};
